import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productListFilterAccordionSectionStyles, {
    accordionSection: {
        panelProps: {
            css: css`
                overflow-y: auto;
                overflow-x: hidden;
                max-height: 350px;
                background: #fff;
            `,
        },
        headerProps: {
            css: css`
                button {
                    background: #ffffff;
                }
            `,
        },
        collapseIconProps: {
            color: "#19A3E0",
            src: "Minus",
            size: 20,
        },
        expandIconProps: {
            color: "#19A3E0",
            src: "Plus",
            size: 20,
        },
    },
    checkBoxGroup: {
        css: css`
            width: 100%;
            & > div {
                label {
                    word-break: break-word;
                    font-size: 14px;
                }
            }
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: #fff;
                border: 1px solid #bebdbd;
                color: #19a3e0;
            }
            span[role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 0 1px #e2e3e6;
            }
            &:not(:last-child) {
                padding-bottom: 0px;
            }
        `,
    },

    seeAllLink: {
        css: css`
            padding-top: 5px;
        `,
    },
    seeLessLink: {
        css: css`
            padding-top: 5px;
        `,
    },
});
